/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import noUiSlider from 'nouislider'
import { useLayout } from '../../../_metronic/layout/core'
import { DefaultTitle } from '../../../_metronic/layout/components/header/page-title/DefaultTitle'
import { KTSVG } from '../../../_metronic/helpers'
import { ThemeModeSwitcher } from '../../../_metronic/partials'
import axios from 'axios'

type Props = {
  show: boolean;
  searching:(category:any,model:any,marque:any)=>void
};

const HeaderItemMachine : React.FC<Props> = ({ show,searching })=>{
  const {classes} = useLayout()
  const [status, setStatus] = useState<string>('')
  const [marques, setMarques] = useState([]);
  const [categories, setCategories] = useState([]);
  const [models, setModels] = useState([]);
  const [idMarque, setidMarque] = useState();
  const getMarques = () => {
      axios
        .get("https://api.machinery.fcpo.ma/api/marques.json")
        .then((response) => {
          setMarques(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    };
    const getDesignation = () => {
      axios
        .get("https://api.machinery.fcpo.ma/api/categories.json")
        .then((response) => {
          setCategories(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    };
    const getModel = (value: any) => {
      setidMarque(value);
      axios
        .get(
          "https://api.machinery.fcpo.ma/api/getmodel/api/marques/" +
            value +
            ".json"
        )
        .then((response) => {
          setModels(response.data);
        })
  
        .catch((error) => {
          console.error(error);
        });
    };
  useEffect(() => {
  getDesignation()
  getMarques()
  
    const rangeSlider = document.querySelector('#kt_toolbar_slider')
    const rangeSliderValueElement = document.querySelector('#kt_toolbar_slider_value')

    if (!rangeSlider || !rangeSliderValueElement) {
      return
    }

    // @ts-ignore
    noUiSlider.create(rangeSlider, {
      start: [5],
      connect: [true, false],
      step: 1,
      format: {
        to: function (value) {
          const val = +value
          return Math.round(val).toString()
        },
        from: function (value) {
          return value
        },
      },
      range: {
        min: [1],
        max: [10],
      },
    })

    // @ts-ignore
    rangeSlider.noUiSlider.on('update', function (values, handle) {
      rangeSliderValueElement.innerHTML = values[handle]
    })

    const handle = rangeSlider.querySelector('.noUi-handle')
    if (handle) {
      handle.setAttribute('tabindex', '0')
    }

    // @ts-ignore
    handle.addEventListener('click', function () {
      // @ts-ignore
      this.focus()
    })

    // @ts-ignore
    handle.addEventListener('keydown', function (event) {
      // @ts-ignore
      const value = Number(rangeSlider.noUiSlider.get())
      // @ts-ignore
      switch (event.which) {
        case 37:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value - 1)
          break
        case 39:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value + 1)
          break
      }
    })
    return () => {
      // @ts-ignore
      rangeSlider.noUiSlider.destroy()
    }
  }, [])

  return (
    <div className='toolbar d-flex align-items-stretch'>
      {/* begin::Toolbar container */}
      <div
        className={`${classes.headerContainer.join(
          ' '
        )} py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-stretch justify-content-lg-between`}
      >
        <DefaultTitle />
        <div className='d-flex align-items-stretch overflow-auto pt-3 pt-lg-0'>
          {/* begin::Action wrapper */}
          <div className='d-flex align-items-center'>
            {/* begin::Label */}
          
            {/* end::Label */}

            {/* begin::Select */}
           {
            show?
            <>
       <select
              className='form-select form-select-sm form-select-solid w-150px w-xxl-125px mr-2'
              data-control='select2'
              data-placeholder='Latest'
              data-hide-search='true'
              defaultValue={status}
              onChange={(e) => searching(e.target.value,"","")}
            >
                            <option value=''>Categorie</option>

                  {categories.map((categorie: any, index) => {
                      return (
                        <option key={index} value={categorie.id}>
                          {categorie.titre}
                        </option>
                      );
                    })}
            </select>
            <select
              className='form-select form-select-sm form-select-solid w-150px w-xxl-125px mr-2'
              data-control='select2'
              data-placeholder='Latest'
              data-hide-search='true'
              defaultValue={status}
              onChange={(e: any) => {
                getModel(e.target.value);
                searching("","",e.target.value)
              }}            >
            
              <option value=''>Marque</option>
             
              {marques.map((marque: any, index) => {
                      return (
                        <option key={index} value={marque.id}>
                          {marque.marque}
                        </option>
                      );
                    })}
            </select>
            <select
              className='form-select form-select-sm form-select-solid w-150px w-xxl-125px'
              data-control='select2'
              data-placeholder='Latest'
              data-hide-search='true'
              defaultValue={status}
              onChange={(e) => searching("",e.target.value,"")}
            >
            
              <option value=''>Model</option>
              {models.map((model: any, index) => {
                      return (
                        <option key={index} value={model.id}>
                          {model.model}
                        </option>
                      );
                    })}
            </select>
            </>:""
           }
            {/* end::Select  */}
          </div>
          {/* end::Action wrapper */}

          {/* begin::Action wrapper */}
          <div className='d-flex align-items-center'>
           

            {/* begin::Label */}
           
            {/* end::Label */}

            {/* begin::NoUiSlider */}
          
            {/* end::NoUiSlider */}

            {/* begin::Separartor */}
            <div className='bullet bg-secondary h-35px w-1px mx-2'></div>
            {/* end::Separartor */}
          </div>
          {/* end::Action wrapper */}

          {/* begin::Action wrapper */}
          <div className='d-flex align-items-center'>
            {/* begin::Label */}
         
            {/* end::Label */}

            {/* begin::Actions */}
            <div className='d-flex'>
              {/* begin::Action */}
              <a
                href='#'
                className='btn btn-sm btn-icon btn-icon-muted btn-active-icon-primary'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_invite_friends'
              >
              </a>
              {/* end::Action */}

              {/* begin::Notifications */}
             
              {/* end::Notifications */}

              {/* begin::Quick links */}
             
              {/* end::Quick links */}

              {/* begin::Theme mode */}
              <div className='d-flex align-items-center'>
                <ThemeModeSwitcher toggleBtnClass='btn btn-sm btn-icon btn-icon-muted btn-active-icon-primary' />
              </div>
              {/* end::Theme mode */}
            </div>
            {/* end::Actions */}
          </div>
          {/* end::Action wrapper */}
        </div>
        {/* end::Toolbar container */}
      </div>
    </div>
  )
}

export {HeaderItemMachine}
